var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Prop } from 'vue-property-decorator';
let ImageInput = class ImageInput extends Vue {
    constructor() {
        super(...arguments);
        this.canvas = null;
        this.context = null;
        this.image = null;
        this.currentRotation = 0;
        this.containerWidth = 0;
        this.imageUrl = null;
        this.isBusy = false;
    }
    mounted() {
        this.createCanvas();
    }
    closeDialog() {
        this.$emit('closed', false);
    }
    saveAvatar() {
        if (!this.canvas) {
            return;
        }
        this.imageUrl = this.canvas.toDataURL();
        this.$emit('imageChanged', this.imageUrl);
        this.isBusy = true;
    }
    createCanvas() {
        if (!this.baseImage) {
            return;
        }
        const container = document.getElementById('canvasContainer');
        if (!container) {
            return;
        }
        this.containerWidth = container.clientWidth;
        this.canvas = document.createElement('canvas');
        if (!this.canvas) {
            return;
        }
        this.context = this.canvas.getContext('2d');
        if (!this.context) {
            return;
        }
        this.image = new Image();
        this.image.src = this.baseImage;
        this.image.onload = () => {
            if (this.image.width > this.containerWidth) {
                const ratio = this.containerWidth / this.image.width;
                const height = this.image.height * ratio;
                this.image.height = height;
                this.image.width = this.containerWidth;
            }
            this.canvas.width = this.image.width;
            this.canvas.height = this.image.height;
            this.context.drawImage(this.image, 0, 0, this.image.width, this.image.height);
            container.appendChild(this.canvas);
        };
    }
    rotateRight() {
        this.currentRotation += 90;
        this.drawRotatedImage(this.currentRotation);
    }
    rotateLeft() {
        this.currentRotation -= 90;
        this.drawRotatedImage(this.currentRotation);
    }
    drawRotatedImage(angle) {
        const toRadians = Math.PI / 180;
        if (!this.canvas || !this.context || !this.image) {
            return;
        }
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        if (this.currentRotation % 180 === 0) {
            this.canvas.width = this.image.width;
            this.canvas.height = this.image.height;
        }
        else {
            this.canvas.width = this.image.height;
            this.canvas.height = this.image.width;
        }
        this.context.save();
        this.context.translate(this.canvas.width / 2, this.canvas.height / 2);
        this.context.rotate(angle * toRadians);
        this.context.drawImage(this.image, -(this.image.width / 2), -(this.image.height / 2), this.image.width, this.image.height);
        this.context.restore();
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Object)
], ImageInput.prototype, "baseImage", void 0);
ImageInput = __decorate([
    Component({
        components: {
        //
        },
    })
], ImageInput);
export default ImageInput;
